exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".context-tree-select-mask{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2010}.context-tree-select{position:absolute;padding:1em;background-color:#fff;border:1px dotted #d3d3d3}.context-tree-select h3{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-95bce2b0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/context-tree-select.vue
// module id = 93
// module chunks = 0